// pixel constants for layouts

// Please see https://github.com/ridewithgps/rwgps-ui/pull/1328 for
// the full context on how we chose this threshold value for collapse
// behavior
export const CONTENT_COLLAPSE_WIDTH = 770

// mirrors $desktop-min from styleguide variables
export const DESKTOP_MIN = 1025
